import LoadingItem from "./LoadingItem";

export default LoadingItem;
